export function accountEmail() {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.user && user.user.email) {
        return user.user.email;
    } else {
        return null;
    }
}

export function userExpirationDate() {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.authorization && user.authorization.expiryDate) {
        return new Date(user.authorization.expiryDate);
    } else {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/utils/account-detail.js